import React from 'react';

import {TaskNodeDetailsSidepanelContentProps} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';

import InputOutputFieldTables from './InputOutputFieldTables';
import {NodeDetailsSidepanelContext} from './NodeDetailsSidepanelContext';

export default function InputOutputFieldsTab(props: TaskNodeDetailsSidepanelContentProps): JSX.Element {
  const context = NodeDetailsSidepanelContext.useContext();

  return (
    <InputOutputFieldTables
      selectedNode={context.selectedNode}
      interactiveFlowchart={context.interactiveFlowchart}
      allSchemasById={context.allSchemasById}
      flowchartTaskSchema={context.flowchartTaskSchema}
      flowchartTaskDefinitionId={context.flowchartTaskDefinitionId}
      flowchartConfigId={context.flowchartConfigId}
      flowchartEditorConfigurator={context.flowchartEditorConfigurator}
      onChangeSelectedFieldId={props.onChangeSelectedFieldId}
      locked={props.locked}
      refetchFlowchartConfig={context.refetchFlowchartConfig}
    />
  );
}
